import logoImg from "@/assets/logo.png";

// Official CareDeserved logo — used exactly as supplied (not redesigned).
// `variant="light"` places the logo on a white rounded surface so it stays
// legible on dark backgrounds (footer, admin sidebar).
export function Logo({ variant = "dark", className = "" }) {
  const img = (
    <img
      src={logoImg}
      alt="CareDeserved LLC — Care Beyond the Ride"
      className="h-full w-auto object-contain"
      loading="eager"
    />
  );
  if (variant === "light") {
    return (
      <span
        data-testid="site-logo"
        className={`inline-flex h-10 items-center rounded-lg bg-white px-2.5 py-1.5 shadow-sm ${className}`}
      >
        {img}
      </span>
    );
  }
  return (
    <span data-testid="site-logo" className={`inline-flex items-center ${className || "h-11"}`}>
      {img}
    </span>
  );
}
